import type { ClipboardEvent } from 'react'

/**
 * Pastes clipboard text into the input without its leading and trailing whitespace, and with each
 * run of whitespace inside it (tabs, line breaks) as one space, replacing the current selection.
 * A single-line input would otherwise drop line breaks and join the words, hiding that several
 * words were pasted (Figma "Word Rules / Pasted Text With Line Breaks or Tabs"). Text with nothing
 * to change pastes normally.
 */
export function pasteTrimmedText(
  event: ClipboardEvent<HTMLInputElement>,
  setValue: (value: string) => void
) {
  const pasted = event.clipboardData.getData('text')
  const cleaned = pasted.trim().replace(/\s+/gu, ' ')

  if (cleaned === pasted) return

  event.preventDefault()

  const input = event.currentTarget
  const start = input.selectionStart ?? input.value.length
  const end = input.selectionEnd ?? input.value.length

  setValue(input.value.slice(0, start) + cleaned + input.value.slice(end))
}
